import type {
  UserStatus,
} from '../types/member.types';

interface StatusBadgeProps {
  status: UserStatus;
}

const STATUS_CONFIG: Record<
  UserStatus,
  {
    label: string;
    className: string;
  }
> = {
  ACTIVE: {
    label: '활성',
    className:
      'bg-green-100 text-green-700',
  },

  PENDING: {
    label: '대기',
    className:
      'bg-yellow-100 text-yellow-700',
  },

  INACTIVE: {
    label: '비활성',
    className:
      'bg-gray-100 text-gray-700',
  },

  WITHDRAWN: {
    label: '탈퇴',
    className:
      'bg-red-100 text-red-700',
  },

  SUSPENDED: {
    label: '정지',
    className:
      'bg-orange-100 text-orange-700',
  },
};

export default function StatusBadge({
  status,
}: StatusBadgeProps) {
  const config =
    STATUS_CONFIG[status];

  return (
    <span
      className={`inline-flex items-center rounded-full px-2.5 py-1 text-xs font-semibold ${config.className}`}
    >
      {config.label}
    </span>
  );
}